// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"2e02a221","453":"e1bd2c4b"}[chunkId] + ".chunk.js";
};